<!--<div-->
<!--  class="relative flex w-full justify-center items-center pt-8  border-t-[1.8px] border-t-beige border-t-opacity-10 shadow-[0_-2px_4px_rgba(0,0,0,0.05)]">-->
<!--  <div class="max-w-[1440px] mx-auto relative flex  justify-center items-center px-[15px] sm:px-[120px]">-->
<!--    <div>-->
<!--      <ln-hero-image-container [imgUrl]="ActiveImage"></ln-hero-image-container>-->
<!--    </div>-->
<!--    <div-->
<!--      class="flex flex-col mx-[36px] sm:mx-[120px] items-center absolute sm:top-[214px] left-0 w-[192px]  sm:w-[526.37px] rounded-full">-->
<!--      <div-->
<!--        class="leading-[121%] sm:ml-[48.86px] sm:mb-[31px] text-blanco text-xl font-semibold  sm:text-xl md:text-4xl lg:text-5xl  font-['Roboto']">-->
<!--        {{'hero.home.title' | transloco}}-->
<!--      </div>-->
<!--      <div-->
<!--        class="leading-[16px] mt-[6px] sm:ml-[48.86px] justify-start text-blanco text-sm font-semibold sm:text-3xl sm:font-semibold font-['Roboto']">-->
<!--        {{'hero.home.subTitle' | transloco}}-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<div
  class="border-t-opacity-10 flex w-full items-center justify-center border-t-[1.8px] border-t-beige pt-8 shadow-[0_-2px_4px_rgba(0,0,0,0.05)]">
  <div
    [ngClass]="[
      currentScreenSize() === 'SM'
        ? 'pl-[15px] pr-[15px]'
        : currentScreenSize() === 'MD'
          ? 'pl-[47px] pr-[44px]'
          : 'pl-[113px] pr-[120px]',
      'relative mx-auto flex max-w-[1440px]',
    ]">
    <ln-hero-image-container [imgUrl]="ActiveImage"></ln-hero-image-container>
    <div
      [ngClass]="[
        currentScreenSize() === 'SM'
          ? 'mt-[32px] w-[198px] pl-[21px]'
          : currentScreenSize() === 'MD'
            ? 'mt-[134px] w-[344px] pl-[31px]'
            : 'mt-[214px] w-[595px] pl-[48px]',
        'absolute flex flex-col justify-start text-start',
      ]">
      <div
        [ngClass]="[
          currentScreenSize() === 'SM'
            ? 'text-xl leading-[24.02px]'
            : currentScreenSize() === 'MD'
              ? 'text-3xl leading-[40px]'
              : 'text-5xl leading-[54.02px]',
          'flex flex-col font-semibold text-blanco',
        ]">
        {{ 'hero.home.title' | transloco }}
      </div>
      <div
        [ngClass]="[
          currentScreenSize() === 'SM'
            ? 'mt-[12px] text-sm'
            : currentScreenSize() === 'MD'
              ? 'mt-[19px] text-xl leading-normal'
              : 'mt-[31px] text-3xl leading-10',
          'flex flex-col font-semibold text-blanco',
        ]">
        {{ 'hero.home.subTitle' | transloco }}
      </div>
    </div>
  </div>
</div>
